import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import useApi from "../../../hook/useApi";
import { useNavigate } from "react-router-dom";

const UnitCount = ({ data: externalData }) => {
  const { AsyncGetApiCall } = useApi();
  const [internalData, setInternalData] = useState(null);
  const navigate = useNavigate();

  const getData = async () => {
    if (externalData) return;
    const response = await AsyncGetApiCall("/analytics/dashboard-main-cards");
    if (response?.success) {
      setInternalData(response?.data);
    }
  };

  useEffect(() => {
    getData();
  }, [externalData]);

  const data = externalData || internalData;

  // Helper function to render arrow and change value
  const renderTrend = (change) => {
    const isPositive = change > 0;
    return (
      <span
        className={`d-inline-flex align-items-center gap-1 ${isPositive ? "text-success-main" : "text-danger-main"
          }`}
      >
        <Icon
          icon={isPositive ? "bxs:up-arrow" : "bxs:down-arrow"}
          className="text-xs"
        />
        {isPositive ? `+${Math.trunc(change)}` : Math.trunc(change)}%
      </span>
    );
  };

  // Define card-specific configurations (icons and background colors)
  const cardConfigs = {
    users: {
      name: "user",
      route: "/users-list",
      icon: "solar:users-group-rounded-bold",
      bgColor: "bg-cyan",
      gradient: "bg-gradient-start-1",
    },
    orders: {
      name: "trade",
      route: "/trading/trades",
      icon: "solar:hand-money-bold",
      bgColor: "bg-purple",
      gradient: "bg-gradient-start-2",
    },
    volume: {
      icon: "solar:chart-square-bold",
      bgColor: "bg-info",
      gradient: "bg-gradient-start-3",
    },
    revenue: {
      icon: "solar:wallet-money-bold",
      bgColor: "bg-success-main",
      gradient: "bg-gradient-start-4",
    },
    brokerage: {
      icon: "solar:wad-of-money-bold",
      bgColor: "bg-red",
      gradient: "bg-gradient-start-5",
    },
  };

  return (
    <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
      {data &&
        Object.entries(data).map(([key, metric]) => (
          <div className="col" key={key}>
            <div
              className={`${cardConfigs[key]?.name === "user" || cardConfigs[key]?.name === "trade" ? "cursor-pointer" : ""} card shadow-none border ${cardConfigs[key]?.gradient || "bg-gradient-start-1"
                } h-100`}
              onClick={() => navigate(cardConfigs[key]?.route || "")}
            >
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-primary-light mb-1">
                      {metric.title}
                    </p>
                    <h6 className="mb-0">{metric.value ?? 0}</h6>
                  </div>
                  <div
                    className={`w-50-px h-50-px ${cardConfigs[key]?.bgColor || "bg-cyan"
                      } rounded-circle d-flex justify-content-center align-items-center`}
                  >
                    <Icon
                      icon={
                        cardConfigs[key]?.icon || "gridicons:multiple-users"
                      }
                      className="text-white text-2xl mb-0"
                    />
                  </div>
                </div>

                {
                  metric.change ? (
                    <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                      {renderTrend(metric?.change ?? 0)}
                      <span>{metric.label}</span>
                    </p>
                  ) : (
                    <p className="fw-medium text-sm text-secondary-light mt-12 mb-0 d-flex align-items-center gap-2">
                      <Icon icon="lucide:arrow-right" className="text-secondary" />
                      <span>{metric.label}</span>
                    </p>
                  )
                }
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default UnitCount;
